import React from 'react';
import { Badge } from '../components/Badge';
import { ArrowRight, Check } from 'lucide-react';
import { Image } from '../components/Image';
import { Link } from '../components/Link';
import { ShieldCheck } from 'lucide-react';
import { Text } from '../components/Text';
import { TrendingUp } from 'lucide-react';
import { Users } from 'lucide-react';
import browse from '../assets/icons/browser.svg';
import finance from '../assets/icons/financing.svg';
import testdrive from '../assets/icons/drive-1.svg';
import drivehome from '../assets/icons/drive-2.svg';
import HeroSearch from '../components/advanced-search';
import AccessoriesSection from '../components/index-selector';
import {FeaturedCars, NewCars} from '../components/hero-display-cars';
import electric from '../assets/images/thumbnails/pickup.png';
import exotic from '../assets/images/thumbnails/exotic.png';
import hatchback from '../assets/images/thumbnails/hatchback.png';
import suv from '../assets/images/thumbnails/suv.png';
import saloon from '../assets/images/thumbnails/sedan.png';
import highend from '../assets/images/thumbnails/luxury.png';
import CarLogosCarousel from '../components/logos-carousel';
import BrowseByBudget from '../components/BrowseByBudget';
import BrowseByFilters from '../components/filter-pills';
import NavBar from "../components/navigation";
import Footer from "../components/Footer";

export const IndexPage = ({ className, children, variant, contentKey, ...props }) => {



  return (
    <>
      <NavBar />
      <div className="text-text">
      
        {/* Hero Section */}
        <section id="hero" className="relative flex items-center justify-center overflow-hidden hero-gradient pt-20 pb-20">
          <div className="absolute inset-0 bg-[url('../assets/cars.png')] bg-contain bg-no-repeat bg-center opacity-20"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-dark/50 to-dark"></div>
          <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 text-center">
            <HeroSearch/>
          </div>
        </section>

       
        <BrowseByFilters/>
         <BrowseByBudget />
        
             {/* Featured Collection */}
        {/* <section id="featured_collection" className="py-12 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex justify-between items-end mb-12">
              <div>
                <p className="text-xl text-muted">Take a look at our featured collection of handpicked vehicles that are currently on offer.</p>
              </div>
              <Link variant="inline" className="hidden md:inline-flex items-center gap-2 text-primary font-bold hover:gap-4 transition-all cursor-pointer" href="/inventory"> View All 
              <ArrowRight className="w-5 h-5" /></Link>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <FeaturedCars />
            </div>
            <div className="text-center mt-12 md:hidden">
              <Link variant="inline" className="inline-flex items-center gap-2 text-primary font-bold cursor-pointer" href="/inventory"> View All Vehicles 
              <ArrowRight className="w-5 h-5" /></Link>
            </div>
          </div>
        </section> */}
       


       <section id="new_arrivals" className="py-24 bg-background">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex justify-between items-end mb-12">
              <div>
                <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark mb-4"> New Arrivals </h2>
                <p className="text-xl text-muted"> Fresh inventory added to our showroom. </p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <NewCars />
            </div>
          </div>
        </section>

        
        
       


 {/* Explore By Category */}
        <section id="explore_by_category" className="py-24 bg-background">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark mb-6"> Explore by Category </h2>
              
            </div>
            <div className="grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-3 lg:gap-8 ">
              <a href="/inventory?bodyType=Sedan" className="relative block h-56 rounded-2xl overflow-hidden group cursor-pointer sm:h-64 lg:h-80 lg:rounded-3xl category-card">
                <Image variant="" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src={saloon} alt="Luxury Sedans" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-6 lg:bottom-8 lg:left-8 lg:right-8">
                  <h3 className="text-lg font-heading font-bold text-white mb-1 sm:text-2xl lg:text-3xl lg:mb-2"> Sedans/Saloons </h3>
                  <p className="hidden text-gray-300 mb-4 sm:block"> The perfect daily driver </p>
                  <Text variant="bold" className="inline-flex items-center text-white font-bold group-hover:gap-2 transition-all"> Explore 
                  <ArrowRight className="w-5 h-5 ml-1" /></Text>
                </div>
              </a>
              <a href="/inventory?bodyType=SUV&bodyType=Pickup" className="relative block h-56 rounded-2xl overflow-hidden group cursor-pointer sm:h-64 lg:h-80 lg:rounded-3xl category-card">
                <Image variant="cover" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src={suv} alt="SUVs" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-6 lg:bottom-8 lg:left-8 lg:right-8">
                  <h3 className="text-lg font-heading font-bold text-white mb-1 sm:text-2xl lg:text-3xl lg:mb-2"> SUVs & Trucks </h3>
                  <p className="hidden text-gray-300 mb-4 sm:block"> High performance beasts </p>
                  <Text variant="bold" className="inline-flex items-center text-white font-bold group-hover:gap-2 transition-all"> Explore 
                  <ArrowRight className="w-5 h-5 ml-1" /></Text>
                </div>
              </a>
              <a href="/inventory?bodyType=Hatchback" className="relative block h-56 rounded-2xl overflow-hidden group cursor-pointer sm:h-64 lg:h-80 lg:rounded-3xl category-card">
                <Image variant="cover" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src={hatchback} alt="Hatchbacks" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-6 lg:bottom-8 lg:left-8 lg:right-8">
                  <h3 className="text-lg font-heading font-bold text-white mb-1 sm:text-2xl lg:text-3xl lg:mb-2"> Hatchbacks </h3>
                  <p className="hidden text-gray-300 mb-4 sm:block"> The perfect kadudu for your errands </p>
                  <Text variant="bold" className="inline-flex items-center text-white font-bold group-hover:gap-2 transition-all"> Explore 
                  <ArrowRight className="w-5 h-5 ml-1" /></Text>
                </div>
              </a>
              <a href="/inventory?fuelType=Electric" className="relative block h-56 rounded-2xl overflow-hidden group cursor-pointer sm:h-64 lg:h-80 lg:rounded-3xl category-card">
                <Image variant="cover" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src={electric} alt="Electric Vehicles" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-6 lg:bottom-8 lg:left-8 lg:right-8">
                  <h3 className="text-lg font-heading font-bold text-white mb-1 sm:text-2xl lg:text-3xl lg:mb-2"> Electric Vehicles </h3>
                  <p className="hidden text-gray-300 mb-4 sm:block"> Sustainable innovation </p>
                  <Text variant="bold" className="inline-flex items-center text-white font-bold group-hover:gap-2 transition-all"> Explore 
                  <ArrowRight className="w-5 h-5 ml-1" /></Text>
                </div>
              </a>
              <a href="/inventory?priceMin=3000000" className="relative block h-56 rounded-2xl overflow-hidden group cursor-pointer sm:h-64 lg:h-80 lg:rounded-3xl category-card">
                <Image variant="cover" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src={exotic} alt="Convertibles" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-6 lg:bottom-8 lg:left-8 lg:right-8">
                  <h3 className="text-lg font-heading font-bold text-white mb-1 sm:text-2xl lg:text-3xl lg:mb-2"> High End vehicles </h3>
                  <p className="hidden text-gray-300 mb-4 sm:block"> Get everything for your buck </p>
                  <Text variant="bold" className="inline-flex items-center text-white font-bold group-hover:gap-2 transition-all"> Explore 
                  <ArrowRight className="w-5 h-5 ml-1" /></Text>
                </div>
              </a>
              <a href="/inventory?bodyType=Coupe" className="relative block h-56 rounded-2xl overflow-hidden group cursor-pointer sm:h-64 lg:h-80 lg:rounded-3xl category-card">
                <Image variant="cover" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" src={highend} alt="Exotic Cars" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-6 lg:bottom-8 lg:left-8 lg:right-8">
                  <h3 className="text-lg font-heading font-bold text-white mb-1 sm:text-2xl lg:text-3xl lg:mb-2"> Exotic Cars </h3>
                  <p className="hidden text-gray-300 mb-4 sm:block"> Rare and exclusive </p>
                  <Text variant="bold" className="inline-flex items-center text-white font-bold group-hover:gap-2 transition-all"> Explore 
                  <ArrowRight className="w-5 h-5 ml-1" /></Text>
                </div>
              </a>
            </div>
          </div>
        </section>

         
        <AccessoriesSection />

   
        
       
        {/* Why Choose My Car */}
        <section id="why_choose_apex_motors" className="py-24 bg-background">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-6xl font-heading font-bold text-dark mb-6"> Why Choose My Car? </h2>
              <p className="text-xl text-muted max-w-3xl mx-auto">
                 We're not just selling cars—we're delivering experiences that redefine automotive excellence. 
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="glass-card rounded-3xl p-8 card-hover cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-2xl flex items-center justify-center mb-6"><ShieldCheck className="w-8 h-8 " /></div>
                <h3 className="text-2xl font-heading font-bold text-dark mb-4"> Certified Quality </h3>
                <p className="text-muted leading-relaxed">
                   Every vehicle undergoes rigorous 150-point inspection to ensure peak performance and reliability. 
                </p>
              </div>
              <div className="glass-card rounded-3xl p-8 card-hover cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-2xl flex items-center justify-center mb-6"><TrendingUp className="w-8 h-8 " /></div>
                <h3 className="text-2xl font-heading font-bold text-dark mb-4"> Premium Selection </h3>
                <p className="text-muted leading-relaxed">
                   Curated inventory of luxury, sports, and electric vehicles from world-renowned manufacturers. 
                </p>
              </div>
              <div className="glass-card rounded-3xl p-8 card-hover cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-2xl flex items-center justify-center mb-6"><Users className="w-8 h-8 " /></div>
                <h3 className="text-2xl font-heading font-bold text-dark mb-4"> Expert Team </h3>
                <p className="text-muted leading-relaxed">
                   Dedicated automotive specialists guide you through every step with transparency and expertise. 
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Your Path To Ownership */}
        <section id="your_path_to_ownership" className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark mb-6"> Your Path to Ownership </h2>
              <p className="text-xl text-muted max-w-3xl mx-auto"> Simple, transparent, and tailored to your needs </p>
            </div>
            <div className="grid md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-heading font-bold text-white"> 1 </div>
                <img src={browse} alt="Browse Inventory" className="mx-auto mb-4 w-12 h-12" />  
                <h3 className="text-xl font-heading font-bold text-dark mb-3"> Browse & Select </h3>
                <p className="text-muted">
                   Explore our inventory online or visit our showroom to find your ideal vehicle. 
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-heading font-bold text-white"> 2 </div>
                <img src={testdrive} alt="Test Drive" className="mx-auto mb-4 w-12 h-12" />
                <h3 className="text-xl font-heading font-bold text-dark mb-3"> Test Drive </h3>
                <p className="text-muted">
                   Experience the performance firsthand with our hassle-free test drive process. 
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-heading font-bold text-white"> 3 </div>
                <img src={finance} alt="Financing" className="mx-auto mb-4 w-12 h-12" />
                <h3 className="text-xl font-heading font-bold text-dark mb-3"> Financing </h3>
                <p className="text-muted">
                   Get pre-approved with competitive rates tailored to your financial goals. 
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-heading font-bold text-white"> 4 </div>
                <img src={drivehome} alt="Drive Home" className="mx-auto mb-4 w-12 h-12" />
                <h3 className="text-xl font-heading font-bold text-dark mb-3"> Drive Home </h3>
                <p className="text-muted">
                   Complete paperwork quickly and drive away in your dream vehicle the same day. 
                </p>
              </div>
            </div>
          </div>
        </section>
       <CarLogosCarousel />

      
    </div>
    <Footer />
    </>
  );
};